import { IAgentCustomSkill } from "../../models/AgentSkills/AgentCustomSkill";
import { ICustomSkill } from "../../models/AgentSkills/CustomSkill";
import styles from "../CustomAccess/styles.module.css";

interface IProps {
  customSkills: Array<ICustomSkill>;
  agentSkills: Array<IAgentCustomSkill>;
  onChange: (id: number, value: string) => void;
  onRemove: (id: number) => void;
}
const CustomSkills = (props: IProps) => {
  return (
    <>
      Custom Skills
      <hr />
      {props.customSkills.map((skill: ICustomSkill, index: number) => {
        const agentSkill = props.agentSkills.find((s) => s.id === skill.id);
        return (
          <div key={index} className={styles.ContainerFlex} style={{ marginBottom: '10px' }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "10px",
                minWidth: "200px",
                maxWidth: "200px",
              }}
            >
              <input
                type="checkbox"
                checked={agentSkill ? true : false}
                onChange={(e) => {
                  if (!e.target.checked) {
                    props.onRemove(skill.id);
                  } else {
                    props.onChange(
                      skill.id,
                      agentSkill ? agentSkill.value : ""
                    );
                  }
                }}
                style={{ marginRight: "5px" }}
              />
              {skill.key}
            </label>
            <input
              className={styles.FormControl}
              type={
                skill.type_id === 1
                  ? "text"
                  : skill.type_id === 2
                  ? "number"
                  : "text"
              }
              id={skill.key}
              value={agentSkill ? agentSkill.value : ""}
              onChange={(e) => {
                props.onChange(skill.id, e.target.value);
              }}
              disabled={!agentSkill}
              style={{ 
                width: "300px",
                marginTop: 0, 
                marginBottom: 0 
              }}
            />
          </div>
        );
      })}
    </>
  );
};

export default CustomSkills;